import React, { useState } from 'react';

import { CrosshairIcon, MinusIcon } from '~/components/icons';
import { useCanvas } from '~/contexts/CanvasContext';
import { EnterKey } from '~/keyboard';

import { Box, IconButton, Input } from './styled';

type ICanvasZoom = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const CanvasZoom: React.FC<ICanvasZoom> = (props) => {
  const context = useCanvas();
  const { zoom, minZoom, maxZoom, update } = context;
  const decimals = (zoom % 1);
  const [newZoom, setNewZoom] = useState<number | null | undefined>();
  const value = newZoom === null ? '' : newZoom ? (newZoom).toFixed(0) : (zoom * 100).toFixed(0)
  return (
    <Box {...props}>
      <IconButton
        disabled={zoom === minZoom}
        onClick={() => {
          const adjustment = !decimals ? .5 : decimals > .5 ? decimals - .5 : decimals;
          update({ zoom: Math.max(zoom - adjustment, minZoom) })
        }}
      >
        <MinusIcon sx={{ width: 14, height: 2 }} />
      </IconButton>
      <Input
        type="number"
        value={value}
        onWheel={(event) => {
          (event.target as HTMLInputElement).blur();
        }}
        onFocus={() => {
          setNewZoom(zoom * 100);
        }}
        onBlur={() => {
          setNewZoom(undefined);
        }}
        onChange={(event) => {
          const zoom = parseInt(event.target.value, 10);
          setNewZoom(isNaN(zoom) ? null : zoom);
        }}
        onKeyDown={(event) => {
          const { key } = event;
          //no decimals / no negative
          if (['-', '.', ','].includes(key)) {
            event.preventDefault();
          } else if (newZoom && key === EnterKey) {
            setNewZoom(undefined);
            update({ zoom: Math.min(Math.max(newZoom / 100, minZoom), maxZoom) });
          }
        }}
      />
      %
      <IconButton
        disabled={zoom === maxZoom}
        onClick={() => {
          const adjustment = !decimals ? .5 : decimals >= .5 ? 1 - decimals : .5 - decimals;
          update({ zoom: Math.min(zoom + adjustment, maxZoom) })
        }}
      >
        <CrosshairIcon sx={{ width: 14, height: 14 }} />
      </IconButton>
    </Box>
  );
}
